export const mileageMock = [
    { name: "2020", value: 0 },
    { name: "2021", value: 20 },
    { name: "2022", value: 60 },
    { name: "2023", value: 80 },
    { name: "2024" },
    { name: "2025" }
];